define('services/composer/surveyFormService',[
    'lib/lodash4',
    'lib/bluebird',
    'services/apiCore',
    'models/composer/forms/Survey'
],
function (
    _,
    Promise,
    apiCore,
    SurveyModel
) {
    "use strict";

    //Construct a survey model(s) from (each) object returned
    function constructSurvey(surveyData) {
        return new SurveyModel(surveyData);
    }

    function constructSurveyList(surveyDataList) {
        return _.map(surveyDataList, constructSurvey);
    }

    //=====================
    // Module Construction
    //=====================
    var module = {
        EXPAND_PUBLISH_HISTORY_FLAG: "publishHistory", //passing expand=publishHistory on a get.page will include publish history metadata
        get: {},
        post: {},
        put: {},
        del: {}
    };
    // GET
    module.get.page = function (data) {
        var endpoint = "/quality/forms/surveys";
        data = _.assign({
            pageSize: 100,
            pageNumber: 1,
            filter: ''
        }, data);

        return apiCore.v2.get(endpoint, data)
            .then(function (response) {
                // add convenience method to strip off paging info
                response.asList = function () {
                    return constructSurveyList(response.entities);
                };
                return response;
            });
    };
    module.get.byId = function (surveyId) {
        var endpoint = "/quality/forms/surveys/" + surveyId;
        return apiCore.v2.get(endpoint)
            .then(function (response) {
                return constructSurvey(response);
            });
    };
    module.get.published = {};
    module.get.published.page = function (data) {
        var endpoint = "/quality/publishedForms/surveys";
        data = _.assign({
            pageSize: 100,
            pageNumber: 1,
            filter: ''
        }, data);

        return apiCore.v2.get(endpoint, data)
            .then(function (response) {
                // add convenience method to strip off paging info
                response.asList = function () {
                    return constructSurveyList(response.entities);
                };
                return response;
            });
    };
    module.get.published.byId = function (surveyId) {
        var endpoint = "/quality/publishedForms/surveys/" + surveyId;

        return apiCore.v2.get(endpoint)
            .then(function (response) {
                return constructSurvey(response);
            });
    };
    module.get.versions = {};
    module.get.versions.byId = function (surveyId) {
        var endpoint = "/quality/forms/surveys/" + surveyId + "/versions";
        return apiCore.v2.get(endpoint)
            .then(function (response) {
                return response;
            });
    };
    // POST
    module.post.create = function (data) {
        var endpoint = "/quality/forms/surveys";
        return apiCore.v2.post(endpoint, data);
    };
    module.post.publish = function (surveyId) {
        var endpoint = "/quality/publishedForms/surveys";
        var data = {
            "id": surveyId
        };
        return apiCore.v2.post(endpoint, data);
    };
    // PUT
    module.put.update = function (surveyId, unwrappedSurveyModel) {
        var endpoint = "/quality/forms/surveys/" + surveyId;
        var data = unwrappedSurveyModel;

        return apiCore.v2.put(endpoint, data);
    };
    // DELETE
    module.del.instance = function (surveyId) {
        var endpoint = "/quality/forms/surveys/" + surveyId;
        return apiCore.v2.del(endpoint);
    };

    return module;
});

